module.exports = __webpack_public_path__ + "media/images/promotions/cards/chance-4-3e8fc69fd30756dcd26d237272fcc328.svg";